import React from 'react';
import "../../App.css";
import { useNavigate } from 'react-router-dom';
import EconoJournalLogo from "../../components/EconoJournalLogo";

export default function PagoFailure() {
  const navigate = useNavigate();

  const btnBackToResume = () => {
    navigate('/');
  };

  return (
    <div className='thanks'>
      <EconoJournalLogo className="logoECJ" />
      <h2>No pudimos procesar el pago</h2>
      <h4>Tu pago no se realizó. Revisá los datos e intentá de nuevo o probá con otro medio.</h4>
      <button onClick={btnBackToResume}>Volver al inicio</button>
    </div>
  );
}
